import React, { useState } from 'react';
import './Logo.css';

const Logo = ({ onLogoClick }) => {
  const [clickCount, setClickCount] = useState(0);

  const handleClick = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);
    if (onLogoClick) {
      onLogoClick(newCount);
    }
  };

  return (
    <div className="logo-container">
      <div className="logo" onClick={handleClick}>
        <div className="logo-icon">
          <div className="hexagon">
            <div className="hexagon-inner">
              <div className="logo-symbol">N</div>
            </div>
          </div>
          <div className="pulse-ring"></div>
          <div className="pulse-ring delay-1"></div>
          <div className="pulse-ring delay-2"></div>
        </div>
        <div className="logo-text">
          <span className="company-name">NORTONEO</span>
          <span className="company-tagline">IT SOLUTIONS</span>
        </div>
      </div>
      {clickCount > 0 && clickCount < 5 && (
        <div className="click-counter">
          {clickCount}/5
        </div>
      )}
    </div>
  );
};

export default Logo;